import FormLabelInput from "../../labels/form.label.input";
import { useState, useRef, useEffect } from "react";
import { ReactComponent as ExpandIcon } from "../../../../assets/icons/expandDown.icon.svg";
import { Link } from "react-router-dom";
import CopyButton from "../../../buttons/copy.button";

const DEFAULT_OPTIONS = [{ value: "default", label: "DEFAULT" }];

const MultiSelectInput = ({
  options = DEFAULT_OPTIONS,
  label,
  value,
  onChange,
  handleCopyClick,
  name,
  parentId,
  otherProps,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  });

  return (
    <div className="w-full">
      <FormLabelInput>{label && `${label}:`}</FormLabelInput>
      <div
        tabIndex={0}
        ref={ref}
        className="font-ubuntuMedium bg-white shadow rounded outline-none gap-[.5em] p-[.5em] flex items-center focus:border focus:shadow-primary relative min-h-[1.5em]"
      >
        <span className="flex flex-wrap gap-1 grow">
          {value?.length > 0 &&
            value.map((v) => (
              <div
                key={v.id}
                className="bg-secondary text-white rounded px-2 py-1 flex gap-2"
              >
                <Link
                  to={`https://techcyclesolutions.repairshopr.com/tickets/${v.ticket_id}`}
                  target="_blank"
                  className="hover:text-primary hover:underline decoration-primary"
                >
                  {v.ticket}
                </Link>
                <span
                  data-parent_id={parentId}
                  data-id={v.id}
                  data-name={name}
                  onClick={onChange}
                  className="cursor-pointer hover:text-primary active:translate-x-px active:translate-y-px text-red-500 font-ubuntuBold px-0"
                >
                  &times;
                </span>
              </div>
            ))}
        </span>
        <CopyButton handleClick={handleCopyClick} />
        <button
          data-name={name}
          data-reset={true}
          onClick={onChange}
          className="active:translate-x-px active:translate-y-px hover:text-red-500 font-ubuntuBold rounded p-0"
        >
          &times;
        </button>
        <div className="self-stretch w-[.05em] bg-stone-500"></div>
        <div>
          <ExpandIcon
            onClick={() => setIsOpen(!isOpen)}
            className="cursor-pointer flex items-center hover:fill-primary min-w-4 min-h-4 w-6 h-4"
          />
        </div>
        <ul
          style={{ top: "calc(100% + .25em)" }}
          className={`${
            isOpen ? "" : "hidden"
          } shadow-lg bg-white z-50 absolute left-0 w-full rounded m-0 p-0 list-none max-h-[15em] overflow-y-auto`}
        >
          {options.map((option) => (
            <li
              key={option?.id}
              data-parent_id={parentId}
              data-id={option?.id}
              data-ticket_id={option?.ticket_id}
              data-number={option?.number}
              data-ticket={option?.ticket}
              data-description={option?.description}
              data-name={name}
              onClick={onChange}
              className={`${
                value?.find((v) => v?.id === option?.id)
                  ? "bg-secondary text-white"
                  : ""
              } shadow m-1 cursor-pointer hover:bg-primary hover:text-secondary rounded px-2 py-1`}
            >
              {option?.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default MultiSelectInput;
